import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const QuickActionButton = () => {
  const navigate = useNavigate();
  const [currentRole] = useState('student');

  const roleActions = {
    student: {
      label: 'Search Jobs',
      icon: 'Search',
      path: '/job-search-application'
    },
    employer: {
      label: 'Post Job',
      icon: 'PlusCircle',
      path: '/job-posting'
    },
    institution: {
      label: 'Manage Programs',
      icon: 'Building2',
      path: '/institution-management'
    },
    admin: {
      label: 'Admin Panel',
      icon: 'Shield',
      path: '/admin-controls'
    }
  };

  const action = roleActions?.[currentRole];

  const handleClick = () => {
    navigate(action?.path);
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 px-6 py-4 bg-accent text-accent-foreground rounded-xl shadow-warm-xl hover:shadow-warm-2xl transition-smooth hover:-translate-y-1 active:scale-97 group"
      aria-label={action?.label}
    >
      <Icon
        name={action?.icon}
        size={24}
        color="currentColor"
        className="group-hover:scale-110 transition-smooth"
      />
      <span className="font-medium hidden sm:inline">{action?.label}</span>
    </button>
  );
};

export default QuickActionButton;